import MailIcon from "@/assets/dark_gradient/mail.svg?react";
import RefluencedLogo from "@/assets/images/refluenced_logo_with_text_black.svg";
import Button from "@/components/Common/Button";
import {client} from "@/httpClient";
import {useMutation} from "@tanstack/react-query";
import {createFileRoute} from "@tanstack/react-router";
import {useTranslation} from "react-i18next";
import {useTitle} from "react-use";

export const Route = createFileRoute("/unsubscribe/$token")({
  component: Unsubscribe,
});

function Unsubscribe() {
  const {token} = Route.useParams();
  const {t} = useTranslation(["unsubscribe"]);
  useTitle(`${t("title")} – Refluenced`);

  const {
    mutate: unsubscribe,
    isPending,
    isSuccess,
    isError,
  } = useMutation({
    mutationFn: () => client.post(`outreach/unsubscribe/${token}/`),
  });

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-10 p-6 sm:p-10">
      <img src={RefluencedLogo} alt="Refluenced" className="h-8 w-auto" />
      <div className="border-neutral-grey-light rounded-2.5xl flex w-full max-w-xl flex-col items-center gap-5 border bg-white px-8 py-10 text-center sm:px-14">
        {isSuccess ? (
          <>
            <span className="bg-success-medium-green/10 flex size-14 items-center justify-center rounded-full">
              <svg viewBox="0 0 24 24" fill="none" className="text-success-medium-green size-7" aria-hidden="true">
                <path
                  d="M4 12.5l5 5L20 6.5"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="text-primary-midnight-dark text-3xl font-bold sm:text-4xl">{t("success_title")}</span>
            <span className="text-neutral-black sm:text-lg">{t("success_description")}</span>
            <span className="text-neutral-grey-dark text-sm">{t("hint")}</span>
          </>
        ) : isError ? (
          <>
            <span className="text-primary-midnight-dark text-3xl font-bold sm:text-4xl">{t("error_title")}</span>
            <span className="text-neutral-black sm:text-lg">{t("error_description")}</span>
          </>
        ) : (
          <>
            <MailIcon className="h-8 w-auto shrink-0" />
            <span className="text-primary-midnight-dark text-3xl font-bold sm:text-4xl">{t("title")}</span>
            <span className="text-neutral-black sm:text-lg">{t("description")}</span>
            <Button
              buttonStyle="Blue"
              className="mt-2 w-full max-w-xs"
              isLoading={isPending}
              isDisabled={isPending}
              onClick={() => unsubscribe()}
              dataTestId="unsubscribe-button">
              {t("unsubscribe")}
            </Button>
            <span className="text-neutral-grey-dark text-sm">{t("hint")}</span>
          </>
        )}
      </div>
    </div>
  );
}
